import * as formatParse from 'common/format-parse';
import { currencyConversion } from 'utils/MobxDataManager/singletons';
import { Format } from './format';
import { observable, action, makeObservable } from 'mobx';
import { editBudgetViewStore } from 'utils/MobxDataManager/singletons';

export type numberValueOnChangeCallback = (newValue: number) => void;

export class NumberValue {
    @observable value: Nullable<number>;
    @observable valueInput: Nullable<string>;
    @observable isHourly: boolean;
    @observable isStockUnit: boolean;
    @observable isMonetaryValue: boolean;
    @observable homeCurrency: string;
    _format: Format;
    @observable onChangeCallback: numberValueOnChangeCallback;

    constructor(format: Format) {
        makeObservable(this);
        this._format = format;
    }

    getValueText(): string {
        if (this.valueInput !== null) {
            return this.valueInput;
        }

        if (this.value == null || this.value <= 0) {
            return '';
        }

        if (this.isMonetaryValue) {
            return currencyConversion.convertCurrencyToDisplay(
                this.homeCurrency,
                this._format,
                this.value,
                false,
                '',
                this.isHourly);
        }

        if (this.isStockUnit) {
            return this._format.formatStockDecimal(this.value);
        }

        return this._format.formatDecimalValue(
            this.value,
            this.isHourly);
    }


    @action
    setValue(value: Nullable<number>): void {
        this.value = (value) ? value : 0;
    }

    @action
    changeValue(newValueText: string): void {
        this.valueInput = formatParse.stripNonCurrency(newValueText);
        this.value = formatParse.parseValueOrDefault(newValueText, 0);
    }

    @action
    onBlur(): void {
        if (this.valueInput === null) {
            return;
        }

        this.valueInput = null;
        if (!this.value) {
            return;
        }
        editBudgetViewStore.setBudgetValue(this.value);
        this.onChangeCallback?.(this.value);
    }

    @action
    setOnChangeCallback(callback: numberValueOnChangeCallback):  void {
        this.onChangeCallback = callback;
    }
}